module.exports = ".group-buttons{\r\n    text-align: center !important;\r\n}\r\n.box-product{\r\n    width: 100%;\r\n}\r\n.product-item{\r\n    width: 32.3%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/brand-salles-of/brand-salles-of.component.css
// module id = ./src/app/components/brand-salles-of/brand-salles-of.component.css
// module chunks = main